module.exports = __webpack_public_path__ + "src/components/Model/dbCode.jpg?9cab4dc8";


//////////////////
// WEBPACK FOOTER
// ./src/components/Model/dbCode.jpg
// module id = 2812
// module chunks = 1